import {
  SAVE_EMAIL_LOGIN_FAIL,
  SAVE_EMAIL_LOGIN_SUCCESS,
} from '../action.types'
import InitialState from '../initial.state'

export default (state = InitialState.saveEmail, action) => {
  switch (action.type) {
    case SAVE_EMAIL_LOGIN_SUCCESS:
      return action.email.email
    case SAVE_EMAIL_LOGIN_FAIL:
      return state
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/account/saveEmail.reducer.js